module.exports = require('./TruncateStringCell');
